module.exports = require('./TruncateStringCell');
